import React from "react";

import { BsPatchCheckFill } from "react-icons/bs";

import "./experience.css";

const frontEnd = [
  { id: 1, title: "HTML5", skillLevel: "Proficient" },
  { id: 2, title: "CSS3", skillLevel: "Proficient" },
  { id: 3, title: "ReactJS", skillLevel: "Proficient" },
  { id: 4, title: "Next.js", skillLevel: "Proficient" },
  { id: 5, title: "TypeScript", skillLevel: "Proficient" },
  { id: 6, title: "Tailwind CSS", skillLevel: "Proficient" },
  { id: 7, title: "Redux Toolkit", skillLevel: "Proficient" },
  { id: 8, title: "Zustand", skillLevel: "Proficient" },
  { id: 9, title: "Material UI", skillLevel: "Proficient" },
  { id: 10, title: "Styled Components", skillLevel: "Proficient" },
  { id: 11, title: "Socket.io", skillLevel: "Intermediate" },
  { id: 12, title: "Bootstrap 5", skillLevel: "Intermediate" },
];

const backEnd = [
  // Runtime & Frameworks
  { id: 1, title: "Node.js", skillLevel: "Proficient" },
  { id: 2, title: "Fastify", skillLevel: "Proficient" },
  { id: 3, title: "Express.js", skillLevel: "Proficient" },

  // Databases & Caching
  { id: 4, title: "PostgreSQL", skillLevel: "Proficient" },
  { id: 5, title: "MySQL", skillLevel: "Proficient" },
  { id: 6, title: "Redis", skillLevel: "Proficient" },
  { id: 7, title: "MongoDB", skillLevel: "Intermediate" },

  // BaaS & Messaging
  { id: 8, title: "Supabase", skillLevel: "Proficient" },
  { id: 9, title: "QStash", skillLevel: "Proficient" },
  { id: 10, title: "Firebase", skillLevel: "Intermediate" },

  // Cloud & Infrastructure
  { id: 11, title: "Docker", skillLevel: "Intermediate" },
  { id: 12, title: "AWS", skillLevel: "Intermediate" },
  { id: 13, title: "Kubernetes", skillLevel: "Familiar" },

  // Languages
  { id: 14, title: "Python", skillLevel: "Basic" },
  { id: 15, title: "Django", skillLevel: "Basic" },
];

const Experience = () => {
  return (
    <section id="experience">
      <h2>My Experience & Skills</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            {frontEnd.map(({ id, title, skillLevel }, index) => (
              <article key={id} className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" />
                <div>
                  <h4
                    style={{
                      animationDelay: `${(Math.random() * 3).toFixed(2)}s`,
                      animationDuration: `${(1.5 + Math.random() * 2).toFixed(2)}s`,
                    }}
                  >
                    {title}
                  </h4>
                  <small className="text-light">{skillLevel}</small>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* End of Front-End */}
        <div className="experience__backend">
          <h3>Backend Development</h3>
          <div className="experience__content">
            {backEnd.map(({ id, title, skillLevel }, index) => (
              <article key={id} className="experience__details">
                <BsPatchCheckFill className="experience__details-icon" />
                <div>
                  <h4
                    style={{
                      animationDelay: `${(Math.random() * 3).toFixed(2)}s`,
                      animationDuration: `${(1.5 + Math.random() * 2).toFixed(2)}s`,
                    }}
                  >
                    {title}
                  </h4>
                  <small className="text-light">{skillLevel}</small>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
